import { BulkTableRow } from '@/components/bulkQueue/types';
import { BulkVisitTarget } from '@/components/bulkQueue/useBulkVisitActions';
import {
    UnifiedVisitOccurrence,
    isUnifiedVisit,
} from '@/components/unifiedVisits/UnifiedVisitOccurrencesTable';
import { VisitState } from '@/types/visit';

// Maps a unified visits row to a target. VisitRequest rows map to null.
export const unifiedRowToTarget = (row: UnifiedVisitOccurrence): BulkVisitTarget | null => {
    if (!isUnifiedVisit(row)) {
        return null;
    }
    return {
        id: row.id,
        permissions: row.permissions,
        hasServices: (row.clinicianAppointments ?? []).some(
            (appointment) => appointment.services.length > 0,
        ),
        isCancellable: row.visitState !== VisitState.ENDED && row.permissions.cancel,
        isEnded: row.visitState === VisitState.ENDED,
        patient: row.patient,
        city: row.visitAddress.city,
    };
};

// Maps a bulk queue row to a target. VisitRequest rows map to null.
export const bulkQueueRowToTarget = (row: BulkTableRow): BulkVisitTarget | null => {
    if (row.__typename !== 'Visit') {
        return null;
    }
    return {
        id: row.id,
        permissions: row.permissions,
        // The bulk queue fragments alias `clinicianAppointments` to `appointments`.
        hasServices: !!row.appointments?.some((appointment) => appointment.services.length > 0),
        isCancellable: row.state !== VisitState.ENDED && row.permissions.cancel,
        isEnded: row.state === VisitState.ENDED,
        patient: row.patient,
        city: row.address.city,
    };
};
